import React from 'react';

export const PlayButtonIcon = () => (
    <svg
        width="44px"
        height="44px"
        viewBox="0 0 48 48"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Create-Updates-June-2019"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="Artboard" transform="translate(-617.000000, -119.000000)">
                <g id="Group-Copy" transform="translate(499.000000, 11.000000)">
                    <g id="Group-2">
                        <g
                            id="play"
                            transform="translate(119.000000, 109.000000)"
                        >
                            <path
                                d="M0,22 C0,9.84979487 9.84979487,0 22,0 C34.1502051,0 44,9.84979487 44,22 C44,34.1502051 34.1502051,44 22,44 C9.84979487,44 0,34.1502051 0,22 Z"
                                id="Stroke-343"
                                stroke="#FFFFFF"
                                strokeWidth="1.12820513"
                                opacity="0.900000036"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <polygon
                                id="Stroke-342"
                                fill="#FFFFFF"
                                points="16.3589744 11.2115385 33.2820513 22.2470769 16.3589744 33.2826154"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

export const getMaxHeights = (location = 'SingleContent') =>
    location === 'SingleContent'
        ? {
              desktop: 750,
              tablet: 750,
              smallTablet: 750,
              mobile: 510,
          }
        : {
              // Feed
              desktop: 540,
              tablet: 540,
              smallTablet: 340,
              mobile: 300,
          };
